export default __webpack_public_path__ + "static/media/add-icon-green-filled.7c68a414.svg";